export const STATUS_DRAFT = 1;
export const STATUS_PRESALE = 2;
export const STATUS_SALESPOINTS_PLUS_DIRECT = 3;
export const STATUS_PAST = 4;
export const STATUS_CANCELLED = 5;
export const STATUS_REFUND = 6;
export const STATUS_SUSPENDED = 7;
export const STATUS_ONLY_SALESPOINTS = 8;
export const STATUS_FREE_ADMISSION = 9;

export const SUBSTATUS_PRE_SALE_ENDED = 21;
export const SUBSTATUS_SOLD_OUT = 22;
export const SUBSTATUS_PRE_SALE_WITH_CODE = 23;
export const SUBSTATUS_SALE_STARTS_ON = 24;
export const SUBSTATUS_TICKETS_UNAVAILABLE = 25;

export const SELF_SERVICE_EXCLUDED_STATUSES = [
  STATUS_DRAFT,
  STATUS_SALESPOINTS_PLUS_DIRECT,
  STATUS_REFUND,
  STATUS_FREE_ADMISSION
]
